import React from 'react';

import styled from 'styled-components';
import { Checkbox, Tag } from '@ontruck/orc';

const t = {
  not_reviewed: 'Not reviewed',
};

const NotReviewedCell = ({ isReviewed, reviewStatus, handleReviewJourney, className }) => {
  const reviewed = isReviewed || (reviewStatus || {}).reviewed;

  return (
    !reviewed && (
      <div
        className={className}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        <Checkbox
          label={t.reviewed}
          size="M"
          checked={isReviewed}
          onChange={handleReviewJourney}
          disabled={(reviewStatus || {}).reviewing}
          dataE2E={'journey_detail__review'}
        />
        <Tag skin="modernRed" weight="bold" textTransform="uppercase">
          {t.not_reviewed}
        </Tag>
      </div>
    )
  );
};

export default styled(NotReviewedCell)`
  display: flex;
  padding-top: 5px;
`;
